import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { GetPermitRegisterPolicies, GetPermitRegisterPoliciesVariables } from "./__generated__/GetPermitRegisterPolicies";

export const GET_PERMIT_REGISTER_POLICIES = gql`
  query GetPermitRegisterPolicies($permitRegisterId: String!, $permitTypeId: String) {
    permitRegisterPolicies(permitRegisterId: $permitRegisterId, permitTypeId: $permitTypeId)
  }
`;

export function useLazyGetPermitRegisterPolicies() {
  const [getPermitRegisterPolicies, { loading, error, data }] = useLazyQuery<GetPermitRegisterPolicies, GetPermitRegisterPoliciesVariables>(
    GET_PERMIT_REGISTER_POLICIES,
    {
      fetchPolicy: "cache-and-network",
      errorPolicy: "all",
    }
  );

  return {
    getPermitRegisterPolicies,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
